<template>
  <div class="header-wrapper">
    <div class="header-left">
      <div class="img-bg">
      </div>
    </div>
    <div class="header-right">
      <div class="menu">
        <el-menu :default-active="activeIndex"
                 class="el-menu-demo"
                 mode="horizontal"
                 background-color="#FFFFFF"
                 text-color="#323232"
                 active-text-color="#013e94"
                 @select="handleSelect">
          <div class="menu-wrap" style="display: inline-block" v-for="(menu, index) in menuList" :key="index">
            <el-submenu v-if="menu.childList.length > 0" :index="index + ''">
              <template slot="title">{{menu.title}}</template>
              <el-menu-item :key="i" v-for="(c, i) in menu.childList"
                            :index="c.route">
                {{c.title}}
              </el-menu-item>
            </el-submenu>
            <el-menu-item v-else  :index="menu.route">{{menu.title}}</el-menu-item>
          </div>
<!--          <i v-if="widthWindow <= 1200" @click="phoneClick" class="el-icon-phone-outline" style="position: absolute;right: 10px;top: 20px;color: white"></i>-->
        </el-menu>
      </div>
<!--      <div style="position: absolute;right: 10px;top: 5px;color: white" v-if="widthWindow > 1200">-->
<!--        <p>联系电话：185-4033-7183</p>-->
<!--      </div>-->

    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      activeIndex: '/',
      widthWindow: document.documentElement.clientWidth,
      menuList: []
    }
  },
  watch: {
    $route (to, from) {
      console.log(to.path)
      this.activeIndex = to.path
    }
  },
  methods: {
    handleSelect (key, keyPath) {
      console.log(key, keyPath)
      this.$router.push(key)
    },
    phoneClick () {
      this.$notify({
        title: '联系电话',
        message: '185-4033-7183',
        type: 'success'
      })
    }
  },
  mounted: function () {
    if (this.$boss) {
      const menus = this.$boss.page000.g000
      let parentList = menus.filter(item => !item.parent)
      let childList = menus.filter(item => item.parent)
      this.menuList = parentList.map(p => {
        p.childList = childList.filter(it => it.parent === p.title)
        return p
      })

      this.activeIndex = this.$route.path
      console.log(this.$route.path)
      // console.log('this.menuList', this.menuList)
    }
  }
}
</script>
<style scoped lang="less">
  .el-menu--horizontal .el-menu .el-menu-item {
    font-size: 1.2rem !important;
  }
  /deep/ .el-submenu__icon-arrow {
    right: 7px !important;
    color: black;
  }
  @media screen and (max-width: 1500px){
    .header-wrapper {
      display: flex;
      width: 100%;
      height: 70px;
      background-color: #FFFFFF;
    }
    .header-left {
      width: 35%;
      .img-bg{
        margin-left: 100px;
        margin-top: 20px;
        width: 180px;
        height: 30px;
        background: url("../../../static/images/logo.png") no-repeat;
        background-size: 100% 100%;
      }
    }
    .sub_text {
      font-size: 1.2rem;
    }
    .header-right {
      margin-right: 20px;
      width: 70%;
      .menu{
        height: 100%;
        width: 100%;
        font-size: 1.2rem;
      }
      /deep/ .el-menu {
        float: right;
      }
      /deep/ .el-menu, .el-menu-item, .el-submenu{
        height: 95%;
        font-size: 1.2rem;
      }
      /deep/.el-submenu .el-submenu__title {
        height: 100% !important;
        font-size: 1.2rem;
      }
      /deep/.el-submenu .el-submenu__title , /deep/ .el-menu-item.is-active {
        border-bottom: 5px solid #013e94;
      }
      /deep/ .el-menu-item.is-active {
        font-weight: bold;
      }
      /deep/ .el-menu.el-menu--horizontal {
        border: 0;
      }
    }
  }
  @media screen and (min-width: 1501px){
    .header-wrapper {
      display: flex;
      width: 100%;
      height: 70px;
      background-color: #FFFFFF;
    }
    .header-left {
      width: 50%;
      .img-bg{
        margin-left: 100px;
        margin-top: 2%;
        width: 25%;
        height: 40%;
        background: url("../../../static/images/logo.png") no-repeat;
        background-size: 100% 100%;
      }
    }
    .sub_text {
      font-size: 1.2rem;
    }
    .header-right {
      margin-right: 100px;
      width: 50%;
      .menu{
        height: 100%;
        width: 100%;
        font-size: 1.2rem;
      }
      /deep/ .el-menu {
        float: right;
      }
      /deep/ .el-menu, .el-menu-item, .el-submenu{
        height: 95%;
        font-size: 1.2rem;
      }
      /deep/.el-submenu .el-submenu__title {
        height: 100% !important;
        font-size: 1.2rem;
      }
      /deep/.el-submenu .el-submenu__title , /deep/ .el-menu-item.is-active {
        border-bottom: 5px solid #013e94;
      }
      /deep/ .el-menu-item.is-active {
        font-weight: bold;
      }
      /deep/ .el-menu.el-menu--horizontal {
        border: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/components/header.vue